@if (showButtons()) {
  <div class="pt-3 flex flex-row" [style]="{width: '62rem'}">
    @if (!processing()) {
      <p-button label="{{ 'investment.label.ausfuehren.cancel' | translate }}" icon="pi pi-replay"
                [disabled]="!this.selectedCustomer()"
                variant="outlined" (onClick)="resetGeschaeft()" severity="secondary"/>
    }
    <div class="flex ml-auto gap-1">
      @if (processing()) {
        <p-button [tabindex]="12" label="{{ 'investment.label.ausfuehren.new' | translate }}" icon="pi pi-refresh"
                  variant="outlined"
                  (onClick)="resetGeschaeft()"/>
      }
      @if (isPrintable()) {
        <p-button [tabindex]="12" label="{{ 'investment.label.ausfuehren.print' | translate }}" icon="pi pi-print"
                  variant="outlined"
                  (onClick)="printPage()"/>
      }
      @if (!processing()) {
        <p-button [tabindex]="12" label="{{ 'investment.label.ausfuehren.execute' | translate }}"
                  [disabled]="executeDisabled() || processing() || tradeTransactionIsProcessing()"
                  icon="pi pi-check-square" variant="outlined" (onClick)="processExecute()"/>
      }
    </div>
  </div>
}
